import React from 'react'
import Slider from '../Slider/Slider'

const Canvas = () => {
    return (
       <div className='canvas'>
        <Slider/>
       </div>
    )
}

export default Canvas